// extracted by mini-css-extract-plugin
export var accordion = "styles-module--accordion--2qdkO";
export var panel = "styles-module--panel--2XPYB";